import { useTranslation } from 'react-i18next';
import SwitchLang from './SwitchLang';
import ConsentPreview from './ConsentPreview';
import TermConditionPreview from './TermConditionPreview';
import { Badge, Button, Tabs, Tooltip } from 'antd';
import TabPane from 'antd/lib/tabs/TabPane';
import { Link } from 'react-router-dom';
import { ROUTER } from '../../../../../constants/router';
import usePermission from '../../../../../hooks/usePermission';

const TemplatePreview = ({
    setPreviewLang,
    previewLang,
    templateSelect,
    templateDetail,
    templateDetailPublish,
    logo,
    logoPublish,
    masterConsent,
    masterTerm,
    templateType,
}) => {
    const { isAuditor } = usePermission();
    const { t } = useTranslation();
    return (
        <div className="bg-white rounded-md shadow-sm w-full p-6">
            <div className="flex items-center justify-between border-b-2 pb-4">
                <div className="">
                    <SwitchLang
                        previewLang={previewLang}
                        setPreviewLang={setPreviewLang}
                    />
                </div>
                <div className="font-semibold">
                    {t('Consent.LastUpdate')} :{' '}
                    <span className="text-sm font-normal">
                        {templateDetail
                            ? `${templateDetail?.updateBy}, ${templateDetail?.updateDate}`
                            : '-'}
                    </span>
                </div>
            </div>
            <div className="flex">
                <Tabs size="small" className="mt-5 w-full">
                    {templateSelect?.status === 'Draft' && (
                        <TabPane
                            tab={
                                <span className="font-semibold">
                                    {t('policy.viewpolicy')}
                                </span>
                            }
                            key="policy"
                        >
                            <Badge.Ribbon
                                text={
                                    templateSelect?.status +
                                    ' ' +
                                    templateSelect?.version
                                }
                                color="#1890FF"
                            >
                                {templateType === 'Consent' ? (
                                    <ConsentPreview
                                        previewLang={previewLang}
                                        templateDetail={templateDetail}
                                        logoCompany={logo}
                                        masterConsent={masterConsent}
                                    />
                                ) : (
                                    <TermConditionPreview
                                        previewLang={previewLang}
                                        templateDetail={templateDetail}
                                        logoCompany={logo}
                                        masterTerm={masterTerm}
                                    />
                                )}
                            </Badge.Ribbon>
                        </TabPane>
                    )}

                    {templateSelect?.status === 'Published' &&
                        !templateSelect?.hasChanged && (
                            <TabPane
                                tab={
                                    <span className="font-semibold">
                                        {t('Preview policy published')}
                                    </span>
                                }
                                key="published"
                            >
                                <Badge.Ribbon
                                    text={
                                        templateSelect?.status +
                                        ' ' +
                                        templateSelect?.latestPublishVersion
                                    }
                                    color="#4ACE8F"
                                >
                                    {templateType === 'Consent' ? (
                                        <ConsentPreview
                                            previewLang={previewLang}
                                            templateDetail={templateDetail}
                                            logoCompany={logo}
                                            masterConsent={masterConsent}
                                        />
                                    ) : (
                                        <TermConditionPreview
                                            previewLang={previewLang}
                                            templateDetail={templateDetail}
                                            logoCompany={logo}
                                            masterTerm={masterTerm}
                                        />
                                    )}
                                </Badge.Ribbon>
                            </TabPane>
                        )}

                    {templateSelect?.status === 'Published' &&
                        templateSelect?.hasChanged && (
                            <>
                                <TabPane
                                    tab={
                                        <span className="font-semibold">
                                            {t('policy.viewpolicy')}
                                        </span>
                                    }
                                    key="policy"
                                >
                                    <Badge.Ribbon
                                        text={
                                            'Last Updated' +
                                            ' ' +
                                            templateSelect?.version
                                        }
                                        color="#1890FF"
                                    >
                                        {templateType === 'Consent' ? (
                                            <ConsentPreview
                                                previewLang={previewLang}
                                                templateDetail={templateDetail}
                                                logoCompany={logo}
                                                masterConsent={masterConsent}
                                            />
                                        ) : (
                                            <TermConditionPreview
                                                previewLang={previewLang}
                                                templateDetail={templateDetail}
                                                logoCompany={logo}
                                                masterTerm={masterTerm}
                                            />
                                        )}
                                    </Badge.Ribbon>
                                </TabPane>
                                <TabPane
                                    tab={
                                        <span className="font-semibold">
                                            {t('Preview policy published')}
                                        </span>
                                    }
                                    key="published"
                                >
                                    <Badge.Ribbon
                                        text={
                                            templateSelect?.status +
                                            ' ' +
                                            templateSelect?.latestPublishVersion
                                        }
                                        color="#4ACE8F"
                                    >
                                        {templateType === 'Consent' ? (
                                            <ConsentPreview
                                                previewLang={previewLang}
                                                templateDetail={
                                                    templateDetailPublish
                                                }
                                                logoCompany={logoPublish}
                                                masterConsent={masterConsent}
                                            />
                                        ) : (
                                            <TermConditionPreview
                                                previewLang={previewLang}
                                                templateDetail={
                                                    templateDetailPublish
                                                }
                                                logoCompany={logoPublish}
                                                masterTerm={masterTerm}
                                            />
                                        )}
                                    </Badge.Ribbon>
                                </TabPane>
                            </>
                        )}
                </Tabs>
                <div className="absolute right-14 mt-6 cursor-pointer hover:opacity-80">
                    <Tooltip title="Edit Template">
                        <Link
                            to={
                                templateType === 'Consent'
                                    ? `${ROUTER.CONSENT_MANAGEMENT.TEMPLATE_DESIGN}/consent/${templateSelect?.templateKey}`
                                    : `${ROUTER.CONSENT_MANAGEMENT.TEMPLATE_DESIGN}/term%20&%20condition/${templateSelect?.templateKey}`
                            }
                        >
                            <Button
                                disabled={isAuditor}
                                type="primary"
                                className="px-8"
                                ghost
                            >
                                {t('Edit')}
                            </Button>
                        </Link>
                    </Tooltip>
                </div>
            </div>
        </div>
    );
};

export default TemplatePreview;
